import { render, staticRenderFns } from "./readResults.vue?vue&type=template&id=1b9eda50&scoped=true"
import script from "./readResults.vue?vue&type=script&lang=js"
export * from "./readResults.vue?vue&type=script&lang=js"
import style0 from "./readResults.vue?vue&type=style&index=0&id=1b9eda50&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9eda50",
  null
  
)

export default component.exports